import { Button } from '@mantine/core';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { If } from '@vision/ui/components';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import classes from './FilterAreaBackButton.module.css';

export interface FilterAreaBackButtonProps {
  fallbackPath?: string;
  label?: string;
  onClick?: VoidFunction;
}

export function FilterAreaBackButton({ fallbackPath, label, onClick }: FilterAreaBackButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasHistory = (window.history.state?.idx ?? 0) > 0;
  const enabled = hasHistory || !!fallbackPath || !!onClick;

  const navigateBack = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (hasHistory) {
      navigate(-1);
      return;
    }

    if (fallbackPath) {
      navigate(fallbackPath, { replace: true });
    }
  };

  return (
    <If value={enabled}>
      <Button
        data-testid="button-filter-area-back"
        variant="transparent"
        onClick={navigateBack}
        classNames={{ root: classes.filterAreaBackButton }}
        leftSection={<FontAwesomeIcon icon={faAngleLeft} className={classes.icon} />}
      >
        {label || t('back')}
      </Button>
    </If>
  );
}
